import React, { useState } from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {status, STATUS_MODEL} from '../../../../../enums/statusEnum';
import { permissionObj } from '../../../../../Helpers/permission';

// The permission to manage passwords is the employee one unless another module uses the details
const DetailsApp = ({userData, managePasswordsPermission = permissionObj.WEB_EMPLOYEE_CAN_MANAGE_PASSWORDS}) => {

    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));
    const canManagePasswords = (DEV || permission?.includes(managePasswordsPermission));
    const { idSet } = useSelector((state) => state.CommonsSlice);
    const userId = idSet || sessionStorage.getItem('id');

    const { t } = useTranslation();
    const userInfoStatusList = useSelector((state) => state?.CompanyEmployeesSlice?.userInfoStatusList);
    let userStatusList = [...userInfoStatusList, ]
    if(parseInt(userData.statusId) === STATUS_MODEL.ACCOUNT_LOCKED){
        userStatusList.push({id: STATUS_MODEL.ACCOUNT_LOCKED, name: status[STATUS_MODEL.ACCOUNT_LOCKED]})
    }

    return {
        t,
        userInfoStatusList: userStatusList,
        DEV,
        permission,
        contractorId,
        supplierId,
        canManagePasswords,
        userId,
    }

}



export default DetailsApp;
